export default __webpack_public_path__ + "static/media/tax.b3809ec3.svg";